export class RequestModel {
  Email: string
  Password: string
  CID: string

  constructor(email: string, password: string, cID: string) {
    this.Email = email
    this.Password = password
    this.CID = cID
  }
}

export class ResponseModel<T = {}> {
  data: T
  messages: string[]
  messages2: { message: string; field: string }[]
  resultCode: ResultCode

  constructor(body: any) {
    this.data = body['data']
    this.messages = body['messages']
    this.messages2 = body['messages2']
    this.resultCode = body['resultCode']
  }
}

// export class ResponseModel2 extends ResponseModel {
//
//     messages2: string[];
//
//     constructor(body: any) {
//         super(body);
//         this.messages2 = body['messages2'];
//     }
// }
//

export class LoginResult {
  userId: number
}

export enum ResultCode {
  Success = 0,
  Error = 1
}
